import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import {
  sendTextMessage,
  sendPostback,
  sendButtonClicksEvent
} from '../../../reducers/history/actions';
import sectionBorderRadius from './sectionBorderRadius';

const disabledTextColor = '#9a9a9a';
const disabledBackgroundColor = '#e5e5e5';
// const disabledBorderColor = '#e5e5e5';

const getButtonColor = (button, primaryColor, secondaryColor) => {
  if (button.disabled) {
    return disabledBackgroundColor;
  } else if (button && button.color && secondaryColor && button.color === 'secondary') {
    return secondaryColor;
  }
  return primaryColor;
};

const getButtonTextColor = (button, primaryColor, secondaryColor) => {
  if (button.disabled) {
    return disabledTextColor;
  } else if (button && button.color && secondaryColor && button.color === 'secondary') {
    return secondaryColor;
  }
  return primaryColor;
};

const ButtonsWrapper = styled.div`
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 6px;
  padding: 15px 10px;
  background-color: ${props => props.theme.botCardMessageBackgroundColor};

  ${sectionBorderRadius};
`;

const ButtonWrapper = styled.div`
  width: 100%;
  height: 44px;
  text-align: center;
  line-height: 44px;
  border-radius: 10px;
  ${({ button }) => (button.disabled ? 'cursor: not-allowed;' : 'cursor: pointer;')};
  background-color: ${props => props.theme.botCardButtonBackgroundColor};
  box-sizing: border-box;
  color: ${({ theme, button }) =>
    getButtonTextColor(
      button,
      theme.botCardButtonTextColor,
      theme.botCardButtonTextColorSecondary
    )};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: bold;

  &:last-child {
    border-bottom: 0;
  }

  &:hover {
    background-color: ${({ theme, button }) =>
      getButtonColor(button, theme.hoverColor, theme.hoverColorSecondary)};
  }
`;

class Button extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isButtonDisabled: false
    };
  }

  handleClick = () => {
    const { button, sendTextMessage, sendPostback } = this.props;

    switch (button.type) {
      case 'postBack':
        if (!this.state.isButtonDisabled) {
          sendPostback({ text: button.value, description: button.title });
        }
        this.setState({
          isButtonDisabled: true
        });
        break;
      case 'imBack':
        if (!this.state.isButtonDisabled) {
          sendTextMessage({ text: button.value, isImBack: true });
        }
        this.setState({
          isButtonDisabled: true
        });
        break;

      case 'call':
      case 'openUrl':
      case 'playAudio':
      case 'playVideo':
      case 'showImage':
      case 'downloadFile':
      case 'signin':
        window.open(button.value, '_blank');
        break;

      default:
        console.log('unknown button type', button.type);
    }

    if (button.analyticsEventName) {
      this.props.sendButtonClicksEvent(button.analyticsEventName);
    }
  };

  render() {
    const { button } = this.props;

    return (
      <ButtonWrapper onClick={this.handleClick} data-test-type="button" button={button}>
        {button.title}
      </ButtonWrapper>
    );
  }
}

const ConnectedButton = connect(null, { sendTextMessage, sendPostback, sendButtonClicksEvent })(
  Button
);

class Buttons extends Component {
  render() {
    const { buttons, isStart, isEnd } = this.props;

    const buttonComponents = buttons.map(button => (
      <ConnectedButton key={button.value} button={button} />
    ));

    const isButtonDisabled = buttons.every(button => button.disabled);

    return (
      <ButtonsWrapper isStart={isStart} isEnd={isEnd} disabled={isButtonDisabled}>
        {buttonComponents}
      </ButtonsWrapper>
    );
  }
}

export default Buttons;



// WEBPACK FOOTER //
// ./src/components/MessageHistory/BotMessage/Buttons.js